import { render, staticRenderFns } from "./HistoryTablePagination.vue?vue&type=template&id=ef369d32"
import script from "./HistoryTablePagination.vue?vue&type=script&lang=js"
export * from "./HistoryTablePagination.vue?vue&type=script&lang=js"
import style0 from "./HistoryTablePagination.vue?vue&type=style&index=0&id=ef369d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports